import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-arrow-left",
  "use": "icon-s-arrow-left-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-arrow-left\"><path fill-rule=\"evenodd\" d=\"M7.97195344 3 0 11.0089749 7.97195344 18.9994391 9.29238536 17.6604964 3.5633151 11.928341 22 11.928341 21.9629785 10.0865236 3.5633151 10.0865236 9.29238536 4.33894264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol